import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6">
          <Shield className="text-red-600" size={40} />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">Access Denied</h1>

        <p className="text-gray-600 mb-6">
          You do not have permission to access this panel. Only admin users can
          access the admin panel.
        </p>

        <p className="text-sm text-gray-500 mb-6">
          If you believe you should have access, please contact the system administrator.
        </p>

        <button
          onClick={() => {
            navigate('/login');
          }}
          className="w-full flex items-center justify-center space-x-2 bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition"
        >
          <ArrowLeft size={20} />
          <span>Back to Login</span>
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
